import { TierListRoutes } from "@ugg/shared/components/TierList/TierListRoutes";
import { RampLeftRail, RampRightRail } from "components/Ads/RampRails";
import { PatchNotesCTAButton } from "components/TierList/TierListNewsBanner";
import { MediaQuery } from "@outplayed/responsive";

// The patch-notes CTA is a WP-GraphQL component living in the website's
// src tree, so the shared route table can't import it — inject it here.
const patchNotesCTA = <PatchNotesCTAButton />;

// TO SHOW A BANNER ON EVERY TIER LIST: uncomment the line below (and its
// import) and pass `bannerSlot={bannerSlot}` to <TierListRoutes /> — that one
// value reaches all nine tier-list routes. It renders between the page nav and
// the filter bar. `sm:hidden` was the previous campaign's choice because the
// desktop layout already carries the patch-notes CTA in the header; drop it if
// the banner should show at every breakpoint.
//
// Kept commented rather than deleted: the plumbing behind it spans nine call
// sites, and losing this line is what made the whole slot read as dead code
// last time. See TierListRoutes' bannerSlot prop.
// const bannerSlot = <StickyNewsBanner className="sm:hidden" />;

export function TierListPage() {
  return (
    <div className="flex justify-center mx-auto w-full max-md:w-full">
      <MediaQuery min="DESKTOP_SMALL" max="DESKTOP_LARGE" renderNullOnFail isClient>
        <div className="flex-1 min-w-0 mr-[-12px]">
          <RampLeftRail className="sticky top-[calc(var(--masthead-height)+100px)] transition-[top]" />
        </div>
      </MediaQuery>
      <div className="flex-none content-side-padding mx-auto w-[1016px] pt-[24px] box-content max-md:w-full max-md:box-border">
        <TierListRoutes patchNotesCTA={patchNotesCTA} />
      </div>
      <MediaQuery min="DESKTOP_SMALL" max="DESKTOP_LARGE" renderNullOnFail isClient>
        <div className="flex-1 min-w-0 ml-[-12px]">
          <RampRightRail className="sticky top-[calc(var(--masthead-height)+100px)] transition-[top]" />
        </div>
      </MediaQuery>
    </div>
  );
}
